module.exports = __webpack_public_path__ + "static/media/favicon.d583c8fd.ico";